// Always-visible Add to Cart (collection cards)

document.addEventListener('submit', function (e) {
  const form = e.target.closest('.mmc-card-atc, form[data-type="add-to-cart-form"]');
  if (!form) return;

  e.preventDefault();

  const btn = form.querySelector('button[type="submit"]');
  const original = btn ? btn.textContent : '';
  if (btn) {
    btn.disabled = true;
    btn.dataset.original = original;
    btn.textContent = 'Adding…';
  }

  const fd = new FormData(form);

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Accept': 'application/json' },
    body: fd
  })
    .then(r => {
      if (!r.ok) throw new Error('Add to cart failed');
      return r.json();
    })
    .then((item) => refreshCartUI(item))
    .then(() => {
      if (!btn) return;
      btn.textContent = 'Added';
      setTimeout(() => {
        btn.disabled = false;
        btn.textContent = btn.dataset.original || 'Add to cart';
      }, 900);
    })
    .catch(() => {
      if (!btn) return;
      btn.disabled = false;
      btn.textContent = btn.dataset.original || 'Add to cart';
      alert('Could not add to cart. Please try again.');
    });
});

async function refreshCartUI(addedItem) {
  // Get fresh cart
  const cart = await fetch('/cart.js').then(r => r.json());

  // 1) Update visible counters
  updateCartCounters(cart.item_count);

  // 2) Fire common events themes listen to
  try { document.dispatchEvent(new CustomEvent('cart:add', { detail: { item: addedItem } })); } catch(_) {}
  try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } })); } catch(_) {}
  try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch(_) {}
  try { window.dispatchEvent(new Event('cart:refresh')); } catch(_) {}

  // 3) Eurus/Alpine: try to refresh & open cart via stores
  try {
    if (window.Alpine && Alpine.store) {
      // Try a few likely store names used by Eurus
      const candidates = ['xCart', 'cart', 'cartDrawer', 'xCartView'];
      for (const name of candidates) {
        const s = Alpine.store(name);
        if (!s) continue;
        // refresh cart data if methods exist
        if (typeof s.refresh === 'function') s.refresh();
        if (typeof s.getCart === 'function') s.getCart();
        if (typeof s.fetch === 'function') s.fetch();
        // open drawer if supported
        if ('open' in s) s.open = true;
      }
    }
  } catch(_) {}

  // 4) Fallback: click a known trigger to open drawer
  openCartDrawerFallback();

  return cart;
}

function updateCartCounters(count) {
  const selectors = [
    '[data-cart-count]',
    '[data-cart-items-count]',
    '.cart-count-badge',
    '.cart-count',
    '.count-bubble',
    '#CartCount',
    '.header__cart-count',
    '#cart-count',
    '[data-header-cart-count]',
  ];
  const els = selectors.flatMap(sel => Array.from(document.querySelectorAll(sel)));
  els.forEach(el => {
    el.textContent = count;
    el.setAttribute('data-cart-count', count);
    if (el.classList.contains('hidden') && Number(count) > 0) {
      el.classList.remove('hidden');
    }
  });
}

function openCartDrawerFallback() {
  const triggers = [
    '[data-open-cart]',
    '[data-drawer-toggle="cart"]',
    '[data-action="open-cart"]',
    '#cart-icon-bubble',
    '.header__cart',
    '.open-cart',
    '[aria-controls*="cart"]'
  ];
  const t = triggers.map(sel => document.querySelector(sel)).find(Boolean);
  if (t) { try { t.click(); return; } catch(_) {} }
  try { document.body.classList.add('cart-drawer-open'); } catch(_) {}
}
